import React from 'react';

export default () => <span className="red-star">*</span>;
